(function(){
'use strict';
// ---------------------------------------------------------------------------
// Plastics-kit cart guard (v3 — modal). If a graphics line item wants plastics
// (Add-On: Plastics = Yes / Plastics Type = New plastic kit) but NO plastic-kit
// product is in the cart, show a centered pop-up modal and disable checkout
// until the customer adds a kit or confirms graphics-only.
//
// v3 uses a position:fixed modal appended to <body>, so it can't be hidden or
// squished by the theme's cart layout (the inline banner failed on desktop).
// ---------------------------------------------------------------------------
var PLASTICS_URL = 'https://thedesignlabco.com/pages/plastics';
var acknowledged = false;   // customer confirmed graphics-only
var dismissedThisView = false; // modal already shown+closed this page view
var LOG = function(){ try { console.log.apply(console, ['[dl-guard]'].concat([].slice.call(arguments))); } catch(e){} };

function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

function propsToPairs(p){
  var out = [];
  if (!p) return out;
  if (Array.isArray(p)) { for (var i=0;i<p.length;i++){ if (p[i]) out.push([''+p[i][0], ''+p[i][1]]); } }
  else { for (var k in p){ if (Object.prototype.hasOwnProperty.call(p,k)) out.push([''+k, ''+p[k]]); } }
  return out;
}
function wantsPlastics(item){
  var pairs = propsToPairs(item.properties);
  for (var i=0;i<pairs.length;i++){
    var key = pairs[i][0].toLowerCase();
    var val = (pairs[i][1]||'').toLowerCase();
    if (key.indexOf('add-on') >= 0 && key.indexOf('plastic') >= 0 && val.indexOf('yes') === 0) return true;
    if (key.indexOf('plastics type') >= 0 && (val.indexOf('added') >= 0 || val.indexOf('new plastic') >= 0)) return true;
  }
  return false;
}
function isPlasticKit(item){
  var t = ((item.product_title || item.title || '') + '').toLowerCase();
  var h = ((item.handle || '') + '').toLowerCase();
  return (/plastic/.test(t) || /plastic/.test(h)) && !(/bolt/.test(t) || /bolt/.test(h));
}
function getCart(){
  return fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin' }).then(function(r){ return r.json(); });
}
function evaluate(cart){
  if (!cart || !cart.items) return { mismatch:false };
  var wants=false, hasKit=false;
  for (var i=0;i<cart.items.length;i++){
    if (wantsPlastics(cart.items[i])) wants=true;
    if (isPlasticKit(cart.items[i])) hasKit=true;
  }
  LOG('items:', cart.items.length, 'wantsPlastics:', wants, 'hasPlasticKit:', hasKit, 'mismatch:', wants && !hasKit);
  return { mismatch: wants && !hasKit };
}
function onCartPage(){ return location.pathname === '/cart' || /^\/cart(\/|\?|#|$)/.test(location.pathname); }

function checkoutButtons(){
  return Array.prototype.slice.call(document.querySelectorAll(
    'button[name="checkout"], input[name="checkout"], [data-checkout], .cart__checkout, .cart__checkout-button, a[href$="/checkout"], .cart__ctas button, .cart-summary button'
  )).filter(function(b){
    var t = (b.innerText || b.value || '').toLowerCase();
    return b.name === 'checkout' || /checkout/.test((b.getAttribute && (b.getAttribute('href')||'')) || '') || /check\s*out/.test(t);
  });
}
function setCheckoutEnabled(on){
  checkoutButtons().forEach(function(b){
    if (on){ b.removeAttribute('disabled'); b.style.pointerEvents=''; b.style.opacity=''; b.removeAttribute('aria-disabled'); }
    else   { b.setAttribute('disabled','disabled'); b.setAttribute('aria-disabled','true'); b.style.pointerEvents='none'; b.style.opacity='0.45'; }
  });
}

// ---- The modal (fixed overlay appended to <body>) ----
function buildModal(){
  var ov = document.getElementById('dlPlasticsModal');
  if (ov) return ov;
  ov = document.createElement('div');
  ov.id = 'dlPlasticsModal';
  ov.style.cssText = 'position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,0.6);';
  ov.innerHTML =
    '<div role="dialog" aria-modal="true" style="background:#fff;max-width:480px;width:100%;border-radius:14px;padding:26px 24px;box-shadow:0 24px 70px rgba(0,0,0,0.4);font-family:inherit;color:#1f2937;box-sizing:border-box;">' +
      '<div style="font-size:21px;font-weight:800;color:#b91c1c;margin-bottom:10px;line-height:1.25;">⚠️ Your plastic kit isn’t in the cart</div>' +
      '<p style="margin:0 0 16px;font-size:15px;line-height:1.55;color:#374151;">You chose <strong>“Add Plastic Kit”</strong> on your graphics order — but plastic kits are a <strong>separate item</strong> and aren’t in your cart yet. Add one so we can ship your new plastics <strong>with free graphic install</strong>.</p>' +
      '<a href="' + PLASTICS_URL + '" style="display:block;text-align:center;background:#dc2626;color:#fff;font-weight:800;padding:14px 18px;border-radius:8px;text-decoration:none;font-size:15px;">Browse Plastic Kits →</a>' +
      '<button type="button" id="dlPlasticsContinue" style="display:block;width:100%;margin-top:10px;background:#f3f4f6;color:#374151;border:1px solid #d1d5db;font-weight:600;padding:12px 18px;border-radius:8px;font-size:13.5px;cursor:pointer;">No thanks — I only want the graphics kit (no plastics)</button>' +
      '<p style="margin:12px 0 0;font-size:11.5px;color:#9ca3af;text-align:center;">Choosing graphics-only means no plastics will be shipped.</p>' +
    '</div>';
  document.body.appendChild(ov);
  // Continue = acknowledge graphics-only.
  ov.querySelector('#dlPlasticsContinue').addEventListener('click', function(){
    acknowledged = true;
    closeModal();
    setCheckoutEnabled(true);
  });
  // Click on the dark backdrop just closes the modal (checkout stays disabled
  // until they add a kit or click Continue) — they can reopen by re-checking.
  ov.addEventListener('click', function(e){ if (e.target === ov){ dismissedThisView = true; closeModal(); } });
  return ov;
}
function openModal(){
  if (acknowledged || dismissedThisView) return;
  var ov = buildModal();
  ov.style.display = 'flex';
}
function closeModal(){
  var ov = document.getElementById('dlPlasticsModal');
  if (ov) ov.style.display = 'none';
}

function apply(){
  return getCart().then(function(cart){
    var r = evaluate(cart);
    if (r.mismatch && !acknowledged){
      setCheckoutEnabled(false);
      openModal();
    } else {
      closeModal();
      setCheckoutEnabled(true);
    }
    return r.mismatch;
  }).catch(function(e){ LOG('cart fetch error', e); return false; });
}

function pollApply(times){
  var n = 0;
  (function tick(){ apply(); if (++n < times) setTimeout(tick, 500); })();
}

function observeCart(){
  var target = document.querySelector('#main, main') || document.body;
  var t=null;
  new MutationObserver(function(){
    clearTimeout(t);
    t = setTimeout(function(){ if (onCartPage()) apply(); }, 350);
  }).observe(target, { childList:true, subtree:true });
}

// Backstop: catch checkout clicks anywhere. If mismatch + not acknowledged,
// stop and show the modal (or route to /cart if not on the cart page).
document.addEventListener('click', function(e){
  if (acknowledged) return;
  var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], [data-checkout]');
  if (!btn) return;
  // Don't block clicks that came from inside our own modal.
  if (e.target.closest && e.target.closest('#dlPlasticsModal')) return;
  e.preventDefault(); e.stopImmediatePropagation();
  getCart().then(function(cart){
    if (evaluate(cart).mismatch){
      dismissedThisView = false;
      if (onCartPage()){ setCheckoutEnabled(false); openModal(); }
      else { window.location.href = '/cart'; }
    } else {
      acknowledged = true;
      var form = btn.closest && btn.closest('form');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else if (form) form.submit();
      else window.location.href = '/checkout';
    }
  }).catch(function(){ window.location.href = '/checkout'; });
}, true);

LOG('loaded v3-modal; cartPage=', onCartPage());
ready(function(){
  if (onCartPage()) pollApply(8);
  observeCart();
});
})();
